export default "__VITE_ASSET__DuNJz9YS__ 672w, __VITE_ASSET__Bl4Yk9iW__ 375w";